import _ from "underscore";

import template from "./templates/list.jst";

import View from "backdraft-app/src/view";
import List from "backdraft-app/src/listing/list";

import AddListItem from "./item";

function newOptions(source) {
  if (source) {
    return Object.create(source);
  }

  return {};
}

function applyDefaultOptions(options = {}) {
  const result = newOptions(options);

  result.className = "add-list";
  if (options.className) {
    result.className += ` ${options.className}`;
  }

  result.listOptions = newOptions(options.listOptions);

  return result;
}

export class ItemsList extends List {
  get itemClass() { return AddListItem; }

  _createNewItem(model) {
    const item = new this.itemClass({ model, readOnly: this.options.readOnly, listTemplateArgs: this.options.listTemplateArgs });
    this.cache.set(model, item);
    this.child(`child${item.cid}`, item);
    return item;
  }
}

export default class AddListView extends View {
  get events() {
    return {
      "click [data-action='add-another']": "_onAddAnother"
    };
  }

  constructor(options) {
    options = applyDefaultOptions(options);

    super(options);

    this.options = options;
    this._verifyParameters();

    if (this.collection.size() === 0) {
      this._addEmptyRow();
    }
  }

  render() {
    this.$el.html(template({ readOnly: this.options.readOnly }));

    const headerView = new this.options.headerContentView({ listTemplateArgs: this.options.listTemplateArgs });
    this.child('header', headerView);
    this.$("[data-mount='header']").html(headerView.render().$el);

    const listOptions = _.extend({}, this.options.listOptions, {
      readOnly: this.options.readOnly,
      collection: this.collection,
      itemContentView: this.options.itemContentView,
      listTemplateArgs: this.options.listTemplateArgs
    });

    const itemList = new ItemsList(listOptions);
    this.child('item-list', itemList);
    this.listenTo(itemList, "item_removed", itemView => {
      this.trigger("item_removed", itemView);
    });

    itemList.render();
    this.$("[data-mount='items']").html(itemList.$el);

    return this;
  }

  _verifyParameters() {
    const missingParameters = [];

    if (!this.collection) {
      missingParameters.push("collection");
    }

    if (!this.options.headerContentView) {
      missingParameters.push("headerContentView");
    }

    if (!this.options.itemContentView) {
      missingParameters.push("itemContentView");
    }

    if (!this.options.createEmptyItem) {
      missingParameters.push("createEmptyItem");
    }

    if (missingParameters.length !== 0) {
      throw new Error(`Missing required parameters: ${missingParameters.join(", ")}`);
    }
  }

  _addEmptyRow() {
    this.collection.add(this.options.createEmptyItem());
  }

  _onAddAnother() {
    this._addEmptyRow();
    this.child("item-list").$(".add-list__item:last-child [data-mount=item-content] input[type=text]:first").focus();

    this.trigger("item_added");
    return false;
  }
}
